module.exports = __webpack_public_path__ + "img/mine.45e9199f.svg";